import { Vector3, SkinnedMesh, Box3, Clock, Mesh, Ray } from 'three';
import Capsule from '@blade-sxp/map/src/controls/CapsuleControls';
// import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { loadePerson, Gender } from '@blade-sxp/map/utils/persons';
import TWEEN from '@tweenjs/tween.js';
const STEPS_PER_FRAME = 6; // 每帧步数
const GRAVITY = 9.8; // 重力
const DurationTime = {
    waitwalk: 0.1,
    walkwait: 0.5,
    walkrun: 0.5,
    waitrun: 0.1,
    runwait: 0.5,
};
class CollisionObject {
    animate;
    animateId = -1;
    targetMesh;
    animation;
    actionName = 'wait';
    controls;
    worldOctree;
    personCollider;
    capsuleMesh;
    worldScene;
    _personPosition = new Vector3(); // 玩家位置
    collisionVelocity = new Vector3(); // 玩家速度
    collisionDirection = new Vector3(); // 玩家方向
    collisionOnFloor = false; // 玩家是否在地面
    keyStates = {}; // 关键状态
    clock;
    vector1 = new Vector3();
    vector2 = new Vector3();
    vector3 = new Vector3();
    isThirdPerspective = true;
    _order = new Vector3(0, 0, -1);
    oldOrder = new Vector3(0, 0, -1);
    orderAlpha = 0;
    mixer;
    skeleton;
    disposeStatus = false;
    isInitPosition = false;
    isStop = false;
    personCollisionsResult = false;
    KeyShift = false;
    tween;
    orderTween;
    constructor(controls, worldOctree, worldScene, isThirdPerspective) {
        this.controls = controls; // 获取控制器
        this.worldOctree = worldOctree; // 获取八叉树
        this.clock = new Clock(); // 创建时钟
        this.worldScene = worldScene; // 获取渲染场景
        this.isThirdPerspective = true; // 获取视野
        this.controls.isThirdPerspective = this.isThirdPerspective; // 调整控制器视野
        // this.controls.enableDamping = false;
        this.controls.near = 1;
        this.controls.object.fov = 35;
        this.controls.object.near = 1;
        this.controls.addEventListener('end', () => this.handleCameraRotate()); // 监听鼠标旋转完成事件
    }
    // 监听人物坐标变化
    get personPosition() {
        return this._personPosition;
    }
    set personPosition(position) {
        this._personPosition = position;
        if (position) {
            this.personPositionWatch(position);
        }
    }
    personPositionWatch(val) {
        if (this.targetMesh) {
            // 设置人物模型位置
            this.targetMesh.position.copy(val);
            this.tween?.stop();
            // 获取人物盒子
            const personBox = new Box3().setFromObject(this.targetMesh);
            const endPosition = new Vector3(val.x, personBox.max.y + 1, val.z);
            const startPosition = new Vector3(val.x, personBox.min.y + 1, val.z);
            let cameraPosition = new Vector3();
            if (this.isThirdPerspective) {
                cameraPosition = endPosition.clone().addScaledVector(this.getForwardVector(), -5);
                cameraPosition.y = val.y + (endPosition.y - val.y) * 3 / 4;
            }
            else {
                // 第一人称视野，相机在人物头顶
                cameraPosition = endPosition;
            }
            const cameraStartPosition = this.controls.object.position.clone();
            const targetStartPosition = this.controls.target.clone();
            const targetEndPosition = startPosition.clone();
            if (this.isInitPosition) {
                const time = Number(cameraStartPosition.distanceTo(cameraPosition) * 10 / 10).toFixed(2);
                this.tween = new TWEEN.Tween({ x1: cameraStartPosition.x, y1: cameraStartPosition.y, z1: cameraStartPosition.z, x2: targetStartPosition.x, y2: targetStartPosition.y, z2: targetStartPosition.z })
                    .stop()
                    .to({
                    x1: cameraPosition.x, y1: cameraPosition.y, z1: cameraPosition.z,
                    x2: targetEndPosition.x, y2: targetEndPosition.y, z2: targetEndPosition.z
                }, time)
                    .onUpdate((obj) => {
                    this.controls.object.position.set(obj.x1, obj.y1, obj.z1);
                    // this.controls.object.lookAt(targetEndPosition);
                    this.controls.target.set(targetEndPosition.x, targetEndPosition.y, targetEndPosition.z);
                })
                    .onComplete(() => {
                    this.controls.object.lookAt(targetEndPosition.clone().addScaledVector(this.getForwardVector(), 1000));
                    this.controls.target.set(targetEndPosition.x, targetEndPosition.y, targetEndPosition.z);
                    this.isInitPosition = false;
                })
                    .start();
            }
            else {
                this.controls.object.position.copy(cameraPosition);
                if (this.isThirdPerspective) {
                    this.controls.target.set(targetEndPosition.x, targetEndPosition.y, targetEndPosition.z);
                }
                else {
                    this.controls.target.copy(cameraPosition.clone().addScaledVector(this.order, 10));
                }
            }
        }
        this.controls.object.updateProjectionMatrix();
    }
    // 监听人物朝向变化
    get order() {
        return this._order;
    }
    set order(val) {
        this._order = val;
        this.targetMesh?.lookAt(this.personPosition.addScaledVector(val, 1000));
    }
    // 初始化模型
    async initTargetMesh() {
        await loadePerson(Gender.MALE).then((res) => {
            this.targetMesh = res.scene;
            if (this.targetMesh) {
                // this.targetMesh.scale.set(1.2, 1.2, 1.2);
                this.targetMesh.traverse(function (node) {
                    if (node instanceof Mesh) {
                        node.castShadow = true;
                        node.receiveShadow = true;
                    }
                });
                this.worldScene.add(this.targetMesh);
                // 获取人物动画
            }
            this.animation = res.animation;
            this.animation?.wait.play();
            this.mixer = res.mixer;
        });
    }
    // 初始化人物
    /**
     *
     * @param position 人物模型出生坐标
     * @param targetMesh 人物模型
     * @returns
     */
    async initCollisionObject(position) {
        // 如果存在人物模型
        if (!position)
            return;
        await this.initTargetMesh();
        this.isInitPosition = true;
        // 更新模型在场景中的位置
        this.targetMesh?.updateMatrixWorld(true);
        const initOrder = new Vector3();
        this.controls.object.getWorldDirection(initOrder);
        initOrder.y = 0;
        this.order = initOrder.normalize().clone();
        this.oldOrder = this.order.clone();
        // 设置人物的位置
        this.personPosition = position.clone();
        // 创建碰撞盒子
        this.targetMesh?.traverse((obj) => {
            if (obj instanceof SkinnedMesh && !this.personCollider) {
                const mesh = obj.clone();
                if (!mesh.geometry.boundingBox) {
                    mesh.geometry.computeBoundingBox();
                }
                const box = new Box3();
                box.copy(mesh.geometry.boundingBox).applyMatrix4(mesh.matrixWorld);
                // 获取胶囊体半径
                const radius = (box.max.x - box.min.x) / 2;
                // 初始化人物胶囊体
                this.personCollider = new Capsule(new Vector3((box.max.x + box.min.x) / 2, box.min.y + radius, (box.max.z + box.min.z) / 2), new Vector3((box.max.x + box.min.x) / 2, box.max.y + radius, (box.max.z + box.min.z) / 2), radius);
                // 如果是第一视角隐藏人物模型
                if (!this.isThirdPerspective && this.targetMesh)
                    this.targetMesh.visible = false;
            }
        });
        // 设置键盘事件
        this.controls.handleTravelKeyDown = (e) => this.keyDown(e);
        this.controls.handleTravelKeyUp = (e) => this.keyUp(e);
        // 设置控制器
        // this.controls.capsuleEnable = true;
        this.controls.enablePan = false;
        this.controls.enableZoom = false;
        this.controls.keys.SWITCH = [67];
        // 更新场景
        this.animate = () => {
            this.update();
            this.animateId = window.requestAnimationFrame(() => this.animate());
        };
        this.animate();
    }
    // 键盘按下
    keyDown(event) {
        // 设置对应按键值为true
        if (event) {
            this.keyStates[event.code] = true;
            this.checkPersonOrder(event);
        }
    }
    // 按键松开
    keyUp(event) {
        if (event?.code === 'KeyC') { // c键切换视野
            this.isThirdPerspective = !this.isThirdPerspective;
            // this.controls.isThirdPerspective = this.isThirdPerspective;
            this.changePerspective();
        }
        if (event?.code === 'ShiftRight' || event?.code === 'ShiftLeft') {
            this.KeyShift = !this.KeyShift;
        }
        if (event) {
            this.keyStates[event.code] = false;
            this.checkPersonOrder(event);
        }
    }
    // 更新
    update() {
        // 设置调用碰撞检测的间隔时间
        const deltaTime = Math.min(0.05, this.clock.getDelta()) / STEPS_PER_FRAME;
        // const deltaTime = Math.min(0.05, this.clock.getDelta());
        // we look for collisions in substeps to mitigate the risk of
        // an object traversing another too quickly for detection.
        for (let i = 0; i < STEPS_PER_FRAME; i++) {
            // 键盘事件控制
            this.collisionControls(deltaTime);
            // 更新位置、是否碰撞、行进方向
            this.updatePerson(deltaTime);
            this.mixer.update(deltaTime);
        }
    }
    // 更新玩家
    updatePerson(deltaTime) {
        if (!this.personCollider || this.isStop)
            return;
        let damping = Math.exp(-4 * deltaTime) - 1; // 设置空气阻力
        // 如果玩家未落地
        if (!this.collisionOnFloor) {
            // 玩家的y方向位置向下变化重力加速度*时间
            this.collisionVelocity.y -= GRAVITY * deltaTime;
            // small air resistance 小空气阻力
            damping *= 0.1;
        }
        // 随时间变化速度在阻力作用下变小
        this.collisionVelocity.addScaledVector(this.collisionVelocity, damping);
        // 计算移动的距离
        const deltaPosition = this.collisionVelocity.clone().multiplyScalar(deltaTime);
        // 移动胶囊体
        this.personCollider.translate(deltaPosition);
        // 移动后进行碰撞检测
        this.personCollisions();
        // 移动小人位置
        if (!this.personCollisionsResult) {
            this.personCollider.translate(deltaPosition.negate());
        }
        else {
            this.personPosition = new Vector3(this.personCollider.start.x, this.personCollider.start.y - this.personCollider.radius, this.personCollider.start.z);
        }
    }
    // 人物碰撞
    personCollisions() {
        if (!this.personCollider)
            return;
        // 获取胶囊体碰撞结果
        const result = this.worldOctree.capsuleIntersect(this.personCollider);
        // 碰撞状态还原
        this.collisionOnFloor = false;
        // 如果碰撞
        if (result) {
            // 碰撞面法线y>0表示碰撞发生在胶囊体于障碍物表面
            this.collisionOnFloor = result.normal.y > 0;
            // 如果胶囊体穿入障碍物内部
            if (!this.collisionOnFloor) {
                // 改变物体运动速度方向a
                this.collisionVelocity.addScaledVector(result.normal, -result.normal.dot(this.collisionVelocity));
            }
            // 移动胶囊体位置到碰撞点
            this.personCollider.translate(result.normal.multiplyScalar(result.depth));
            this.personCollisionsResult = true;
        }
        else {
            // 试探下方是否有地面，没有的话如果xz平面上有速度分量则向该速度的反方向移动，如果没有抛出出生点选择错误，销毁已加载模型，等待重新选择出生地
            const testRay = new Ray(this.personCollider.start, new Vector3(0, -1, 0));
            const testResult = this.worldOctree.rayIntersect(testRay);
            if (testResult) {
                this.personCollider.translate(testResult.position.clone().sub(this.personCollider.start.clone()));
                this.personCollisionsResult = true;
            }
            else {
                this.personCollisionsResult = false;
                if (this.collisionVelocity.x === 0 && this.collisionVelocity.z === 0) {
                    console.warn('Birth point error');
                    this.cleanPerson();
                }
                else {
                    this.collisionVelocity = new Vector3();
                }
            }
        }
    }
    // 处理摄像机旋转
    handleCameraRotate() {
        if (!this.isThirdPerspective) {
            this.order = this.getForwardVector().clone();
            this.oldOrder = this.order.clone();
            this.orderAlpha = 0;
            this.checkPersonOrder();
        }
    }
    // 获取前后的方向
    getForwardVector() {
        const collisionDirection = new Vector3();
        this.controls.object.getWorldDirection(collisionDirection);
        collisionDirection.y = 0;
        collisionDirection.normalize();
        return collisionDirection;
    }
    // 获取左右速度分量
    getSideVector() {
        const collisionDirection = new Vector3();
        this.controls.object.getWorldDirection(collisionDirection);
        collisionDirection.y = 0;
        collisionDirection.normalize();
        collisionDirection.cross(this.controls.object.up);
        return collisionDirection;
    }
    // 按键控制
    collisionControls(deltaTime) {
        if (this.isStop)
            return;
        let speedDelta = deltaTime * (this.collisionOnFloor ? 10 : 16);
        if (this.KeyShift) {
            speedDelta = speedDelta * 2;
        }
        if (this.keyStates['KeyW'] || this.keyStates['ArrowUp']) {
            this.collisionVelocity.add(this.getForwardVector().multiplyScalar(speedDelta));
        }
        if (this.keyStates['KeyS'] || this.keyStates['ArrowDown']) {
            this.collisionVelocity.add(this.getForwardVector().multiplyScalar(-speedDelta));
        }
        if (this.keyStates['KeyA'] || this.keyStates['ArrowLeft']) {
            this.collisionVelocity.add(this.getSideVector().multiplyScalar(-speedDelta));
        }
        if (this.keyStates['KeyD'] || this.keyStates['ArrowRight']) {
            this.collisionVelocity.add(this.getSideVector().multiplyScalar(speedDelta));
        }
    }
    // 人物朝向处理
    checkPersonOrder(event) {
        if (event && !['KeyA', 'KeyD', 'KeyS', 'KeyW', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.code))
            return;
        let newOrder = new Vector3();
        let name = 'wait';
        let isRun = false; // 默认站立
        if (this.KeyShift) {
            isRun = true;
        }
        if (this.keyStates['KeyW'] || this.keyStates['ArrowUp']) {
            newOrder = newOrder.add(this.getForwardVector().clone());
        }
        if (this.keyStates['KeyS'] || this.keyStates['ArrowDown']) {
            newOrder = newOrder.add(this.getForwardVector().negate().clone());
        }
        if (this.keyStates['KeyA'] || this.keyStates['ArrowLeft']) {
            newOrder = newOrder.add(this.getSideVector().negate().clone());
        }
        if (this.keyStates['KeyD'] || this.keyStates['ArrowRight']) {
            newOrder = newOrder.add(this.getSideVector().clone());
        }
        if (newOrder.x === 0 && newOrder.y === 0 && newOrder.z === 0) {
            name = 'wait';
            this.isStop = true;
        }
        else {
            name = 'walk';
            this.isStop = false;
            if (this.order.clone().angleTo(newOrder.clone()) !== 0) {
                const angle = this.oldOrder.angleTo(newOrder);
                this.orderAlpha = Number((this.orderAlpha + 0.2).toFixed(1));
                let unitOrder = this.oldOrder.clone().cross(newOrder.clone()).normalize();
                unitOrder = unitOrder.equals(new Vector3(0, 0, 0)) ? new Vector3(0, 1, 0) : unitOrder;
                this.order = this.oldOrder.clone().applyAxisAngle(unitOrder, angle * this.orderAlpha);
                if (this.orderAlpha === 1)
                    this.orderAlpha = 0;
            }
            else {
                this.oldOrder = this.order;
                this.orderAlpha = 0;
            }
        }
        name = isRun && name === 'walk' ? 'run' : name;
        if (this.actionName !== name) {
            const duration = DurationTime[this.actionName + name] || 0.5;
            this.animation?.[this.actionName].crossFadeTo(this.animation?.[name], duration, true);
            this.actionName = name;
        }
        if (this.animation) {
            this.animation[name].enabled = true;
            this.animation[name].play();
        }
    }
    // 切换视角
    changePerspective() {
        if (!this.personCollider || !this.targetMesh)
            return;
        if (this.isThirdPerspective) {
            // 设置人物可见
            this.targetMesh.visible = true;
            this.controls.object.fov = 35;
            this.controls.object.near = 1;
        }
        else {
            // 设置人物不可见
            this.targetMesh.visible = false;
            this.controls.object.fov = 35;
            this.controls.object.near = 1;
        }
        this.controls.object.updateProjectionMatrix();
        const personPosition = this.personCollider.start.clone();
        personPosition.y = personPosition.y - this.personCollider.radius;
        this.personPosition = personPosition;
    }
    // 清除小人
    cleanPerson() {
        window.cancelAnimationFrame(this.animateId);
        if (this.targetMesh) {
            this.targetMesh?.traverse((obj) => {
                if (obj instanceof Mesh) {
                    obj.geometry.dispose();
                    obj.material.dispose();
                }
                if (obj.parent) {
                    obj?.parent.remove(obj);
                }
                obj.clear();
            });
            this.worldScene.remove(this.targetMesh);
        }
        this.targetMesh = undefined;
        this.personCollider = null;
        this._personPosition = new Vector3(); // 玩家位置
        this.collisionVelocity = new Vector3(); // 玩家速度
        // this.collisionDirection = new Vector3(); // 玩家方向
        this.isInitPosition = false;
    }
    // 结束
    dispose() {
        this.clock.stop();
        this.tween?.stop();
        this.orderTween?.stop();
        this.tween = undefined;
        this.orderTween = undefined;
        // 清除人物模型
        this.cleanPerson();
        // 清楚新增的控制器事件
        this.controls.removeEventListener('end', () => this.handleCameraRotate());
        this.controls.handleTravelKeyDown = () => { };
        this.controls.handleTravelKeyUp = () => { };
        // 还原第三视角
        this.controls.isThirdPerspective = true;
        this.controls.near = 10;
        this.controls.minPolarAngle = 0;
        this.controls.maxPolarAngle = Math.PI / 2;
        this.controls.object.fov = 45;
        this.controls.enablePan = true;
        this.controls.enableZoom = true;
        this.controls.target.set(this.controls.target0.x, this.controls.target0.y, this.controls.target0.z);
        // this.controls.target.copy(this.controls.object.position.clone());
        // this.controls.object.position.copy(this.controls.object.position.clone().addScaledVector(new Vector3(0, 1, 0), this.controls.object.position.y * 4));
        // this.controls.object.lookAt(this.controls.target);
    }
}
export default CollisionObject;
